"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedModelList = void 0;
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var ModelList_1 = require("./ModelList");
var PaginatedModelList = /** @class */ (function (_super) {
    __extends(PaginatedModelList, _super);
    function PaginatedModelList(modelClass) {
        var _this = _super.call(this, modelClass) || this;
        _this.modelClass = modelClass;
        _this.isLoadingNextPage = false;
        _this.search = lodash_1.debounce(function (searchQuery, searchKey) {
            if (searchKey === void 0) { searchKey = 'search_query'; }
            return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.loading && this.cancelRequest();
                            return [4 /*yield*/, _super.prototype.load.call(this, this.url, __assign(__assign({}, this.params), (_a = { page: '1' }, _a[searchKey] = searchQuery, _a)), { dataKey: null })];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }, 500);
        _this.setIsLoadingNextPage = function (loading) { return (_this.isLoadingNextPage = loading); };
        return _this;
    }
    Object.defineProperty(PaginatedModelList.prototype, "totalPages", {
        get: function () {
            var _a;
            return ((_a = this._meta) === null || _a === void 0 ? void 0 : _a.total) || 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "perPage", {
        get: function () {
            var _a;
            return ((_a = this._meta) === null || _a === void 0 ? void 0 : _a.per_page) || 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "lastPage", {
        get: function () {
            var _a;
            return ((_a = this._meta) === null || _a === void 0 ? void 0 : _a.last_page) || 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "currentPage", {
        get: function () {
            var _a;
            return ((_a = this._meta) === null || _a === void 0 ? void 0 : _a.current_page) || 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "firstPageUrl", {
        get: function () {
            var _a;
            return ((_a = this._links) === null || _a === void 0 ? void 0 : _a.first) || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "lastPageUrl", {
        get: function () {
            var _a;
            return ((_a = this._links) === null || _a === void 0 ? void 0 : _a.last) || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "isFirstPage", {
        get: function () {
            return this.currentPage === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "isLastPage", {
        get: function () {
            return this.lastPage === this.currentPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "isLoadedAll", {
        get: function () {
            return !!this.lastPage && this.loaded;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "nextPage", {
        get: function () {
            return this.currentPage + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedModelList.prototype, "prevPage", {
        get: function () {
            return this.currentPage - 1;
        },
        enumerable: false,
        configurable: true
    });
    PaginatedModelList.prototype.loadNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLastPage) {
                            return [2 /*return*/];
                        }
                        this.setIsLoadingNextPage(true);
                        return [4 /*yield*/, _super.prototype.load.call(this, this.url, __assign(__assign({}, this.params), { page: this.nextPage.toString() }), {
                                dataKey: null,
                                paginated: true,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaginatedModelList.prototype.load = function (url, params, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.load.call(this, url, params, {
                            dataKey: (config === null || config === void 0 ? void 0 : config.dataKey) || null,
                            forceRefresh: config === null || config === void 0 ? void 0 : config.forceRefresh,
                            useAuth: config === null || config === void 0 ? void 0 : config.useAuth,
                            paginated: true,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaginatedModelList.prototype.deserialize = function (items) {
        var _this = this;
        if (!items) {
            this.setLoaded(true);
            return;
        }
        var models = items.map(function (item) { return _this.modelClass.fromJson(item); });
        if (this.isLoadingNextPage) {
            this.appendItems(models);
            this.setIsLoadingNextPage(false);
        }
        else {
            this.setItems(models);
        }
        this.setLoaded(true);
    };
    PaginatedModelList.prototype.cancelRequest = function () {
        this.setLoading(false);
        this.setIsLoadingNextPage(false);
        // this.apiService.cancelRequest(this.requestId!);
    };
    PaginatedModelList.prototype.onSuccess = function (response) {
        this._meta = response.meta;
        this._links = response.links;
        _super.prototype.onSuccess.call(this, response.data);
    };
    __decorate([
        mobx_1.observable
    ], PaginatedModelList.prototype, "isLoadingNextPage", void 0);
    __decorate([
        mobx_1.observable
    ], PaginatedModelList.prototype, "_links", void 0);
    __decorate([
        mobx_1.observable
    ], PaginatedModelList.prototype, "_meta", void 0);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "totalPages", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "perPage", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "lastPage", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "currentPage", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "firstPageUrl", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "lastPageUrl", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "isFirstPage", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "isLastPage", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "isLoadedAll", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "nextPage", null);
    __decorate([
        mobx_1.computed
    ], PaginatedModelList.prototype, "prevPage", null);
    __decorate([
        mobx_1.action
    ], PaginatedModelList.prototype, "setIsLoadingNextPage", void 0);
    __decorate([
        mobx_1.action
    ], PaginatedModelList.prototype, "loadNext", null);
    __decorate([
        mobx_1.action
    ], PaginatedModelList.prototype, "load", null);
    __decorate([
        mobx_1.action
    ], PaginatedModelList.prototype, "deserialize", null);
    __decorate([
        mobx_1.action
    ], PaginatedModelList.prototype, "cancelRequest", null);
    __decorate([
        mobx_1.action
    ], PaginatedModelList.prototype, "onSuccess", null);
    return PaginatedModelList;
}(ModelList_1.ModelList));
exports.PaginatedModelList = PaginatedModelList;
